import React from 'react'
import Table from '../../../form/component/Table'
import VipIcon from '../../../form/component/VipIcon'
import renderLanguageFamily from '../../../internationalization/renderLanguageFamily'
import { renderCountryName } from '../../../customer/util/names'

export default (isTablet, isPartner) => {
    const displayColumnList = isTablet ? columnListTablet : columnListDesktop

    if (!isPartner) {
        return [
            ...displayColumnList,
            {
                property: 'partnerPhysicianName',
                header: 'Partner',
                columnName: 'partnerPhysicianName',
            },
            {
                property: 'treatingPhysicianName',
                header: 'Treating',
                columnName: 'treatingPhysicianName',
            },
        ]
    }

    return displayColumnList
}

const columnListDesktop = [
    {
        property: 'vip',
        header: 'VIP',
        width: '45',
        renderer: customer => {
            return <VipIcon active={!!customer.vip} />
        },
        columnName: 'customer_customer.vip',
    },
    {
        property: 'referenceNumber',
        header: 'Number',
        columnName: 'customer_customer.referenceNumber',
    },
    {
        property: 'created',
        header: 'Created',
        renderer: Table.dateTimeRenderer('created'),
        columnName: 'customer_customer.created',
    },
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'customer_customer.firstName',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'customer_customer.lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'customer_customer.email',
    },
    {
        property: 'phone',
        header: 'Phone',
        columnName: 'customer_customer.phone',
    },
    {
        property: 'zip',
        header: 'ZIP',
        columnName: 'customer_customer.zip',
    },
    {
        property: 'city',
        header: 'City',
        columnName: 'customer_customer.city',
    },
    {
        property: 'language',
        header: 'Language',
        columnName: 'customer_customer.language',
        renderer: renderLanguageFamily,
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (customer) => {
            return renderCountryName(customer.countryCode)
        },
        columnName: 'customer_customer.countryCode',
    },
]

const columnListTablet = [
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'customer_customer.created',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'customer_customer.lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'customer_customer.email',
    },
    {
        property: 'phone',
        header: 'Phone',
        columnName: 'customer_customer.phone',
    },
    {
        property: 'zip',
        header: 'ZIP',
        columnName: 'customer_customer.zip',
    },
    {
        property: 'city',
        header: 'City',
        columnName: 'customer_customer.city',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (customer) => {
            return renderCountryName(customer.countryCode)
        },
        columnName: 'customer_customer.countryCode',
    },
]



// WEBPACK FOOTER //
// ./src/modules/customer/component/search/customer-column-list.js